"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentPhotoIdCreateFormPurposesEnum = exports.AttachmentPhotoIdCreateFormToJSON = exports.AttachmentPhotoIdCreateFormFromJSONTyped = exports.AttachmentPhotoIdCreateFormFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function AttachmentPhotoIdCreateFormFromJSON(json) {
    return AttachmentPhotoIdCreateFormFromJSONTyped(json, false);
}
exports.AttachmentPhotoIdCreateFormFromJSON = AttachmentPhotoIdCreateFormFromJSON;
function AttachmentPhotoIdCreateFormFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': _1.AcuantResultEnumFromJSON(json['result']),
        'documentClass': _1.AcuantDocumentClassEnumFromJSON(json['documentClass']),
        'alerts': (json['alerts'].map(_1.AcuantAlertModelFromJSON)),
        'documentNameWithoutSeries': json['documentNameWithoutSeries'],
        'scanAttemptNumber': json['scanAttemptNumber'],
        'acuantFields': (json['acuantFields'].map(_1.AcuantFieldFromJSON)),
        'acuantResponseJSON': json['acuantResponseJSON'],
        'ambassadorOverride': !runtime_1.exists(json, 'ambassadorOverride') ? undefined : json['ambassadorOverride'],
        'purposes': json['purposes'],
    };
}
exports.AttachmentPhotoIdCreateFormFromJSONTyped = AttachmentPhotoIdCreateFormFromJSONTyped;
function AttachmentPhotoIdCreateFormToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'result': _1.AcuantResultEnumToJSON(value.result),
        'documentClass': _1.AcuantDocumentClassEnumToJSON(value.documentClass),
        'alerts': (value.alerts.map(_1.AcuantAlertModelToJSON)),
        'documentNameWithoutSeries': value.documentNameWithoutSeries,
        'scanAttemptNumber': value.scanAttemptNumber,
        'acuantFields': (value.acuantFields.map(_1.AcuantFieldToJSON)),
        'acuantResponseJSON': value.acuantResponseJSON,
        'ambassadorOverride': value.ambassadorOverride,
        'purposes': value.purposes,
    };
}
exports.AttachmentPhotoIdCreateFormToJSON = AttachmentPhotoIdCreateFormToJSON;
/**
* @export
* @enum {string}
*/
var AttachmentPhotoIdCreateFormPurposesEnum;
(function (AttachmentPhotoIdCreateFormPurposesEnum) {
    AttachmentPhotoIdCreateFormPurposesEnum["FACIALIDENTIFICATION"] = "FACIAL_IDENTIFICATION";
    AttachmentPhotoIdCreateFormPurposesEnum["FINGERPRINTIDENTIFICATION"] = "FINGERPRINT_IDENTIFICATION";
    AttachmentPhotoIdCreateFormPurposesEnum["CITIZENSHIP"] = "CITIZENSHIP";
    AttachmentPhotoIdCreateFormPurposesEnum["NAMELINKING"] = "NAME_LINKING";
    AttachmentPhotoIdCreateFormPurposesEnum["PHOTOID"] = "PHOTO_ID";
})(AttachmentPhotoIdCreateFormPurposesEnum = exports.AttachmentPhotoIdCreateFormPurposesEnum || (exports.AttachmentPhotoIdCreateFormPurposesEnum = {}));
//# sourceMappingURL=AttachmentPhotoIdCreateForm.js.map